<template>
  <div class="login-page">
    <button class="wechat-btn" @click="toLogin">微信登录</button>
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router'
import { registerOrLogin } from '../api'
import config from '../config/config'
import { onMounted } from 'vue'
import { setToken } from '@/utils/utils'

const router = useRouter()

onMounted(() => {
  const code = new URLSearchParams(window.location.search).get('code')
  if (code) {
    handleLogin(code)
  }
})

async function toLogin() {
    let appId = config.appId;
    let redirectUri = encodeURIComponent(config.redirectUri);
      //唤起微信登录
    var requestUrl =
        "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
        appId +
        "&redirect_uri=" +
        redirectUri +
        "&response_type=code&scope=snsapi_userinfo&state=1#wechat_redirect";

    window.location.href = requestUrl;
}

async function handleLogin(code) {
  // 模拟获取 weixinCode，实际项目中应通过微信SDK获取
  const weixinCode = code
  try {
    const res = await registerOrLogin({ weixinCode, agreementFlag: 1 })
    if (res.data && res.data.data && res.data.data.token) {
      setToken(res.data.data.token)
      localStorage.setItem('bindPhoneV2', res.data.data.bindPhone ? "1" : "0")
      // 返回上一页面
      router.replace('/')
    } else {
      alert('登录失败')
    }
  } catch (e) {
    // alert('登录失败')
  }
}
</script>

<style scoped>
.login-page {
  max-width: 300px;
  margin: 300px auto 0 auto;
  padding: 0;
  text-align: center;
}
.wechat-btn {
  width: 100%;
  padding: 12px;
  background: #09bb07;
  color: #fff;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
}
.wechat-btn:hover {
  background: #07a507;
}
</style> 